// extracted by mini-css-extract-plugin
export var acitonButtons = "_9q-0";
export var additionalIcon = "_9q-f";
export var block = "_9q-1";
export var blockContent = "_9q-7";
export var blockDescription = "_9q-8";
export var blockIcon = "_9q-9";
export var blockTitle = "_9q-6";
export var border = "_9q-a";
export var center = "_9q-l";
export var edge = "_9q-b";
export var edgeLabel = "_9q-c";
export var edgePath = "_9q-d";
export var error = "_9q-e";
export var flowchart = "_9q-g";
export var flowchartContent = "_9q-h";
export var highlighted = "_9q-3";
export var hover = "_9q-4";
export var icon = "_9q-i";
export var left = "_9q-m";
export var navButton = "_9q-j";
export var navButtons = "_9q-k";
export var right = "_9q-n";
export var selected = "_9q-2";
export var small = "_9q-5";